import React, { useState } from 'react';
import { ShareDataModalContainer } from './shareDataModal.styles';
import { ReactComponent as CloseIcon } from "../../../../assets/svgs/icons/close-icon.svg";
import { Button, Modal, Tabs } from 'antd';
import ShareDetails from './shareDetails/ShareDetails';
import SharedUserDetails from './sharedUser/SharedUserDetails';
import { DataIndexItem } from '../../../../types/interfaces';


interface ShareModalProps {
    setShow: (b: boolean) => void;
    selectedItems?: DataIndexItem[];
}

const ShareDataModal = ({ setShow, selectedItems }: ShareModalProps) => {
    const handleCancel = () => {
        setShow(false);
    };

    const tabItems = [
        {
            label: <span>Share</span>,
            key: "1",
            children: (
                <>
                    <ShareDetails handleCancel={handleCancel} selectedItems={selectedItems}/>
                </>
            ),
        },
        {
            label: <span>Shared With</span>,
            key: "2",
            children: (
                <>
                    <SharedUserDetails handleCancel={handleCancel}/>
                </>
            ),
        },
    ];

    return (
        <Modal
            centered
            open={true}
            onCancel={handleCancel}
            className="batch_modal create_batch_modal quota_modal"
            closeIcon={
                <CloseIcon key="CloseIcon" color="#ffffff" onClick={handleCancel} />
            }
            footer={null}
            style={{
                backgroundColor: "#36BDBE",
                width: "100%", // Adjust the width as per your need
                maxWidth: "100%", // Set maximum width if needed
            }}
        >
            <ShareDataModalContainer>
                <div className="table-container">
                    <div className="custom-tab-container">
                        <Tabs
                            defaultActiveKey="1"
                            items={tabItems}
                            key="1"
                            className="custom-tabs custom_payment_tabs"
                        ></Tabs>
                    </div>
                </div>
            </ShareDataModalContainer>
        </Modal>
    );
}

export default ShareDataModal;
